import { Component, input } from '@angular/core';

import { LinkComponent as UiLinkComponent } from '@camelot/ui';

import { RichParagraphLink } from '../../../services/dto/types/rich-text';
import { TextComponent } from '../text/text.component';

@Component({
  selector: 'cam-rich-paragraph-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  imports: [UiLinkComponent, TextComponent],
})
export class LinkComponent {
  link = input.required<RichParagraphLink>();

  public goTo() {
    window.open(this.link().url);
  }
}
